import React, { useEffect, useState } from 'react'
import { RoundCard, RunnerUpHeader, UnderLine } from '../../ui'
import Button from '../../library/components/Button'

import './index.css'
import { useGetObjectStoreFileQuery } from '../../services/objectStoreServices'
import { useGetFilePathQuery } from '../../services/finalizeGenerateViewTransmitService'
import LeftMenu from '../AnalyticsModule/Left'
import RunnerUpHeaderNew from '../../ui/runnerUpHeader/RunnerUpHeaderNew'

const Index = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('ENG')
  const [selectedD_Language, setSelectedD_Language] = useState('ENG')
  const [path, setpath] = useState('')
  const { data: GetFilePath } = useGetFilePathQuery()
  const {
    data: GetUploadPath,
    refetch,
    isLoading: apiLoading,
  } = useGetObjectStoreFileQuery(GetFilePath?.payload?.[0]?.[path], {
    skip: path === '' || path === undefined || path === null ? true : false,
  })
  const Alanguage = [
    'ASM',
    'BEN',
    'ENG',
    'HIN',
    'GUJ',
    'KAN',
    'KON',
    'MLM',
    'MAN',
    'MAR',
    'ORI',
    'PUN',
    'TAM',
    'TEL',
    'URD',
  ]
  const Dlanguage = [
    'ASM',
    'BEN',
    'ENG',
    'HIN',
    'GUJ',
    'KAN',
    'KON',
    'MLM',
    'MAN',
    'MAR',
    'ORI',
    'PUN',
    'TAM',
    'TEL',
    'URD',
  ]

  useEffect(() => {
    if (GetUploadPath) {
      var win = window.open()
      win.document.write(
        '<iframe src="' +
        `data:application/pdf;base64,${GetUploadPath.file}` +
        '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>',
      )
      setpath('')
    }
  }, [GetUploadPath])

  return (
    <LeftMenu>

      <div className="tamplate container-fluid">
        <div className="box shadow ">
         <RunnerUpHeaderNew title={'Master Template'} />
          <div className="row mb-2">
            <div className="col-md-4">
              <label>List of Content Page</label>
            </div>
            <div className="col-md-8">
              <a target=" _blank">
                {/* <Button
                  onClick={() => {
                    setpath('contentPagePath')
                  }}
                  value="View"
                  btnClass="view-btn"
                /> */}
                {/* <button type="button" className="btn btn-primary btn-sm " onClick={() => {
                  setpath('contentPagePath')
                }}>
                  View
                  <span className="pl-2">
                    <i className='fa-solid fa-eye'>
                    </i>
                  </span>
                </button> */}
                <i className='fa-solid fa-eye'
                  onClick={() => {
                    setpath('contentPagePath')
                  }}
                  style={{ cursor: "pointer",color:"blue" }}>
                </i>

              </a>
            </div>
          </div>
          <UnderLine />
          <div className="row my-2">
            <div className="col-md-4">
              <label>Form 13-A - Declaration By Elector</label>
            </div>
            <div className="col-md-8">
              {Alanguage.map((lng) => (
                <Button
                  onClick={() => setSelectedLanguage(lng)}
                  value={lng}
                  btnClass={
                    lng === selectedLanguage ? 'lng-btn-selected' : 'lng-btn'
                  }
                />
              ))}
              <a target=" _blank">
                {/* <Button
                  onClick={() => {
                    setpath('form13AEngPath')
                  }}
                  value="View"
                  btnClass="view-btn"
                /> */}
                {/* <button type="button" className="btn btn-primary btn-sm "  onClick={() => {
                    setpath('form13AEngPath')
                  }}>
                  View
                  <span className="pl-2">
                    <i className='fa-solid fa-eye'>
                    </i>
                  </span>
                </button> */}
                <i className='fa-solid fa-eye'
                  onClick={() => {
                    setpath('form13AEngPath')
                  }}
                  style={{ cursor: "pointer",color:"blue" }}>
                </i>
              </a>
            </div>
          </div>
          <UnderLine />

          <div className="row  my-2">
            <div className="col-md-4">
              <label>
                Form 13-B - Cover-A (Inner Envelope) & <br/> Form 13-C - Cover-B (Outer Envelope) for Assembly Constituency
              </label>
            </div>
            <div className="col-md-8">
              <a target=" _blank">
                {/* <Button
                  onClick={() => {
                    setpath('form13BAssemblyConstituencyPath')
                  }}
                  value="View"
                  btnClass="view-btn"
                /> */}
                <i className='fa-solid fa-eye' onClick={() => {
                  setpath('form13BAssemblyConstituencyPath')
                }} style={{ cursor: "pointer",color:"blue" }}>
                </i>
              </a>
            </div>
          </div>
          <UnderLine />
          <div className="row  my-2">
            <div className="col-md-4">
              <label>
                Form 13-B - Cover-A (Inner Envelope) & <b/>Form 13-C - Cover-B (Outer Envelope) for Parliamentary
                Constituency
              </label>
            </div>
            <div className="col-md-8">
              <a target=" _blank">
                {/* <Button
                  onClick={() => {
                    setpath('form13BParliamentaryConstituencyPath')
                  }}
                  value="View"
                  btnClass="view-btn"
                /> */}
                <i className='fa-solid fa-eye'
                  onClick={() => {
                    setpath('form13BParliamentaryConstituencyPath')
                  }}
                  style={{ cursor: "pointer",color:"blue" }}>
                </i>
              </a>
            </div>
          </div>
          <UnderLine />
          <div className="row  my-2">
            <div className="col-md-4">
              <label>
                Form 13-D - Instructions for the Guidance of Elector
              </label>
            </div>
            <div className="col-md-8">
              {Dlanguage.map((lng) => (
                <Button
                  onClick={() => setSelectedD_Language(lng)}
                  value={lng}
                  btnClass={
                    lng === selectedD_Language ? 'lng-btn-selected' : 'lng-btn'
                  }
                />
              ))}
              <a target=" _blank">
                {/* <Button
                  onClick={() => {
                    setpath('form13DInstructionEngPath')
                  }}
                  value="View"
                  btnClass="view-btn"
                /> */}
                <i className='fa-solid fa-eye'
                  onClick={() => {
                    setpath('form13DInstructionEngPath')
                  }}
                  style={{ cursor: "pointer",color:"blue" }}>
                </i>
              </a>
            </div>
          </div>
          <UnderLine />
          <div className="row  my-2">
            <div className="col-md-4">
              <label>Blank Page</label>
            </div>
            <div className="col-md-8">
              <a target=" _blank">
                {/* <Button
                  onClick={() => {
                    setpath('blankPagePath')
                  }}
                  value="View"
                  btnClass="view-btn"
                /> */}
                <i className='fa-solid fa-eye'
                  onClick={() => {
                    setpath('blankPagePath')
                  }}
                  style={{ cursor: "pointer",color:"blue" }}>
                </i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </LeftMenu>
  )
}

export default Index
